import * as React from 'react'
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui/breadcrumb'
import { Link } from 'react-router-dom'

export type BreadcrumbItem = {
  title: string
  url?: string
}

interface BreadcrumbNavProps {
  items: Array<BreadcrumbItem>
  className?: string
}

export function BreadcrumbNav({ items, className }: BreadcrumbNavProps) {
  if (!items || items.length === 0) {
    return null
  }

  return (
    <div className={className}>
      <Breadcrumb>
        <BreadcrumbList>
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <BreadcrumbItem className='text-lg'>
                {item.url && index < items.length - 1 ? (
                  <BreadcrumbLink asChild>
                    <Link
                      to={item.url}
                      className='text-gray-400 hover:underline'
                    >
                      {item.title}
                    </Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>{item.title}</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {index < items.length - 1 && <BreadcrumbSeparator />}
            </React.Fragment>
          ))}
        </BreadcrumbList>
      </Breadcrumb>
    </div>
  )
}
